import { render, staticRenderFns } from "./RequestExpire.vue?vue&type=template&id=07a9d435&"
import script from "./RequestExpire.vue?vue&type=script&lang=js&"
export * from "./RequestExpire.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports